import { ApiPrefixes, PublicApiSlugs } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';

export class AddressConnector {
  private slug = PublicApiSlugs.ADDRESS;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  search(query: string, index?: 'address' | 'parcel' | 'poi', type?: string): Observable<unknown> {
    let url = `${this.slug}/search?q=${query}`;
    if (index) {
      url += `&index=${index}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    return this.apiCaller.getRequest<unknown>(ApiPrefixes.PUBLIC, url);
  }
}
